import { useContext } from "react";
import { BsPerson } from "react-icons/bs";
import { GoLocation } from "react-icons/go";
import { FaRegClock } from "react-icons/fa";
import Context from "../../../../Context";
import calculateAge from "../../../../controllers/calculateAge";
import { MdNumbers, MdOutlineWorkOutline } from "react-icons/md";
import CardForItem from "../../../customUiForCs/CardForItem";
import parseDropDownValue from "../../../../controllers/utils/parseDropDownValue";
import contractTypesForSite from "../../../../data/employee/contractTypesForSite";
import employeeShiftTypes from "../../../../data/employee/employeeShiftTypes";
import { useTranslation } from "react-i18next";

export default function EmployeeCard({ data, onCardClick }) {
  const { t } = useTranslation();
  const { employeeFunctions } = useContext(Context);

  return (
    <CardForItem
      makeRed={!data.isActive}
      data={data}
      onCardClick={onCardClick}
      itemType={"PROFILE"}
      pagePath={"employee"}
      itemID={data._id}
      editPath={"edit-employee"}
      // image={data.profileImage}
      // title={`${data.lastName} ${data.firstName} ${data.nickname ? " - " + data.nickname : ""}`}
      title={`${data.lastName} ${data.firstName}`}
      // bubbleTexts={[
      //   data.accountType.toLowerCase(),
      //   data.isActive ? "Actif" : "Inactif",
      // ]}
      line1={[
        {
          icon: <MdNumbers />,
          text: `${data.registrationNumber}`,
        },
        {
          icon: <GoLocation />,
          text: `${data.site ? data.site.placeName?.toUpperCase() : "Non"}`,
        },

        {
          icon: <GoLocation />,
          text: `${data.zone ? data.zone.name?.toUpperCase() : "Non"}`,
        },
      ]}
      line2={[
        {
          icon: <MdOutlineWorkOutline />,
          text: `Fonction : ${
            parseDropDownValue({
              query: data.employeeResponsibility,
              theArray: employeeFunctions || contractTypesForSite,
            }) || "Non"
          }`,
        },
        {
          icon: <FaRegClock />,
          text: `Shift : ${
            parseDropDownValue({
              query: data.shift,
              theArray: employeeShiftTypes,
            }) || "Non"
          }`,
        },
      ]}
    />
  );
}
